import { render, staticRenderFns } from "./UpdateMsgModal.vue?vue&type=template&id=77d2c4d6&scoped=true"
import script from "./UpdateMsgModal.vue?vue&type=script&lang=js"
export * from "./UpdateMsgModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateMsgModal.vue?vue&type=style&index=0&id=77d2c4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d2c4d6",
  null
  
)

export default component.exports